/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowphotoai3Inputs */

const en_aiflowphotoai3 = /** @type {(inputs: Aiflowphotoai3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design with AI`)
};

const de_aiflowphotoai3 = /** @type {(inputs: Aiflowphotoai3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit KI gestalten`)
};

/**
* | output |
* | --- |
* | "Design with AI" |
*
* @param {Aiflowphotoai3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowphotoai3 = /** @type {((inputs?: Aiflowphotoai3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowphotoai3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowphotoai3(inputs)
	return de_aiflowphotoai3(inputs)
});
export { aiflowphotoai3 as "aiFlowPhotoAi" }